import React from 'react';
import 'contents/assets/scss/page/data.scss';
function Index() {
  return (
    <main className="com_container p_data">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu4_1">자료실 메인</h2>
          <section className="com_board_search">
            <article className="search">
              <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
              <button className="com_btn gray ws s icon_search"></button>
            </article>
          </section>
        </section>
        <section className="com_pg_container">
          <div className="box_wrap">
            {/* 수능 공지사항 */}
            <section className="box box-half">
              <div className="detail_tit dot">자료실 공지사항</div>
              <div className="com_board_list__scroll">
                <table className="com_board_list">
                  <colgroup>
                    <col width="15%" />
                    <col width="15%" />
                    <col width="auto" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>등록일</th>
                      <th>카테고리</th>
                      <th>내용</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                      return (
                        <tr key={idx}>
                          <td className="td_date">
                            <span className="icon_new" />
                            2022,03,07
                          </td>
                          <td>국어</td>
                          <td>
                            <p className="memo">자연계 공지가 떴습니다.</p>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </section>
            {/* 학교별 시험 분석 */}
            <section className="box box-half">
              <div className="detail_tit dot">학교별 시험 분석</div>
              <div className="com_board_list__scroll">
                <table className="com_board_list">
                  <colgroup>
                    <col width="15%" />
                    <col width="15%" />
                    <col width="auto" />
                    <col width="15%" />
                    <col width="15%" />
                  </colgroup>
                  <tbody>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                      return (
                        <tr key={idx}>
                          <td className="td_date">
                            <span className="icon_new" />
                            2022,03,07
                          </td>
                          <td>홍길동 103</td>
                          <td>
                            <p className="memo">12월 공지입니다.</p>
                          </td>
                          <td>5</td>
                          <td>2</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </section>
          </div>
          <div className="box_wrap">
            {/* 수업 연구자료 */}
            <section className="box box-half">
              <div className="detail_tit dot">수업 연구자료</div>
              <div className="com_board_list__scroll">
                <table className="com_board_list">
                  <colgroup>
                    <col width="15%" />
                    <col width="12%" />
                    <col width="18%" />
                    <col width="auto" />
                    <col width="15%" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>등록일</th>
                      <th>영역</th>
                      <th>학교명</th>
                      <th>제목</th>
                      <th>등록자</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                      return (
                        <tr key={idx}>
                          <td className="td_date">
                            <span className="icon_new" />
                            2022,03,07
                          </td>
                          <td>국어</td>
                          <td>서울고</td>
                          <td>
                            <p className="memo">서울고 2학기 중간고사서울고 2학기 중간고사서울고 2학기 중간고사</p>
                          </td>
                          <td>홍길동 103</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </section>
            {/* 이지팟 문제은행 */}

            <section className="box box-half">
              <div className="detail_tit dot">이지팟 문제은행</div>
              <div className="com_board_list__scroll">
                <table className="com_board_list">
                  <colgroup>
                    <col width="13%" />
                    <col width="10%" />
                    <col width="10%" />
                    <col width="10%" />
                    <col width="8%" />
                    <col width="8%" />
                    <col width="8%" />
                    <col width="8%" />
                    <col width="8%" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>등록일</th>
                      <th>영역</th>
                      <th>년도</th>
                      <th>출처</th>
                      <th>구분1</th>
                      <th>구분2</th>
                      <th>구분3</th>
                      <th>구분4</th>
                      <th>구분5</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                      return (
                        <tr key={idx}>
                          <td className="td_date">
                            <span className="icon_new" />
                            2022,03,07
                          </td>
                          <td>국어</td>
                          <td>2022</td>
                          <td>나무교사교육</td>
                          <td>-</td>
                          <td>-</td>
                          <td>-</td>
                          <td>-</td>
                          <td>-</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </section>
          </div>
        </section>
      </div>
    </main>
  );
}

export default Index;
